var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort0(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H20C20.8284 0.5 21.5 1.17157 21.5 2V20C21.5 20.8284 20.8284 21.5 20 21.5H2C1.17157 21.5 0.5 20.8284 0.5 20V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0623 15.8579L7.06224 7.09191L7.78955 7.81816L8.58505 7.02266L6.4998 4.93742L4.41455 7.02266L5.21005 7.81816L5.93724 7.09191L5.9373 15.8579H7.0623ZM12.1248 7.42041V6.29541H9.3123V7.42041H12.1248ZM13.8123 10.2329V9.10791H9.3123V10.2329H13.8123ZM15.4998 13.0454V11.9204H9.3123V13.0454H15.4998ZM17.1873 15.8579V14.7329H9.3123V15.8579H17.1873Z",
    fill: "#0E6AED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H20C20.8284 0.5 21.5 1.17157 21.5 2V20C21.5 20.8284 20.8284 21.5 20 21.5H2C1.17157 21.5 0.5 20.8284 0.5 20V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "#D1D6DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort0);
export default __webpack_public_path__ + "static/media/sort0.63f078983920f5b267d4c82646505b8e.svg";
export { ForwardRef as ReactComponent };